module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('navigation'), _vm._v(" "), _c('home-title'), _vm._v(" "), _c('home-button')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37bfd02a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/spa/Home/Home.vue
// module id = 267
// module chunks = 0